import axios from 'axios';
import { useState } from 'react';
import { MdStar, MdStarBorder } from 'react-icons/md';

import { ChatMessageFeedback } from '@/shared/api/types/chat-message-feedback';
import { env } from '@/shared/lib';

type Props = {
  messageId: string;
  feedback?: ChatMessageFeedback;
};

export const MessageFeedback = ({ messageId, feedback }: Props) => {
  const [rating, setRating] = useState<number | null>(feedback?.rating ?? null);
  const [comment, setComment] = useState(feedback?.comment ?? '');
  const [submitted, setSubmitted] = useState<boolean>(Boolean(feedback));
  const [loading, setLoading] = useState(false);

  const canSubmit = rating !== null && !submitted;

  const submit = async () => {
    if (!canSubmit) return;

    setLoading(true);

    try {
      await axios.post(
        `${env.VITE_API_URL}api/feedback`,
        {
          message_id: messageId,
          rating,
          comment: comment || undefined,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        },
      );

      /**
       * Backend вернул feedback → переводим в read-only
       * Обновление IMessage делается на уровне chat store / ws / refetch
       */
      setSubmitted(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mt-2">
      <div className="flex items-center gap-1">
        {[1, 2, 3, 4, 5].map((star) => {
          const filled = star <= (rating ?? 0);

          return filled ? (
            <MdStar
              key={star}
              className={`${submitted ? 'cursor-default' : 'cursor-pointer'} text-yellow-500`}
              onClick={() => !submitted && setRating(star)}
            />
          ) : (
            <MdStarBorder
              key={star}
              className={`${submitted ? 'cursor-default' : 'cursor-pointer'} text-gray-400`}
              onClick={() => !submitted && setRating(star)}
            />
          );
        })}
      </div>

      {submitted && (
        <div className="mt-1 text-sm text-gray-500">{feedback?.comment ?? comment}</div>
      )}

      {!submitted && rating !== null && (
        <>
          <textarea
            className="mt-2 w-full text-sm border rounded p-1"
            placeholder="Комментарий (опционально)"
            maxLength={500}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
          />

          <button
            onClick={submit}
            disabled={loading}
            className="mt-1 text-sm text-blue-600 disabled:opacity-50"
          >
            Отправить
          </button>
        </>
      )}
    </div>
  );
};
